<div class="modal-body">
										
    <h4 class="modal-title newReturn_popHeader col-xs-9">{{"returnsUK.exitpopuptitle" | cxTranslate}}</h4>
    <div class="col-xs-3">
        <span class="newReturn_popClose" data-dismiss="modal" (click)="closeDialog()">×</span>
    </div>
    <p class="newReturn_popSubHeader col-xs-12">{{"returnsUK.exitpopupmsg" | cxTranslate}}</p>
    <div class="clearboth"></div>
    <div class="newReturnPopBtnParent">
        <button class="newReturn_popExitBtn" (click)="goToreturn()">{{"returnsUK.exitnloselabel" | cxTranslate}}</button>
        <button class="newReturn_popBackBtn" (click)="closeDialog()">{{"returnsUK.gobacklabel" | cxTranslate}}</button>
    </div>
    
</div>
